import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { cn } from '@bem-react/classname'

import { Checkbox } from '@/components/Form/Checkbox'
import { Tag } from '@/components/UI/Tag'

import { RegisterPoliciesModel } from '../../models/Register.model'
import './PoliciesStep.scss'

interface IPoliciesStepProps {
  className?: string
}

const cnPoliciesStep = cn('PoliciesStep')

export const PoliciesStep: FC<IPoliciesStepProps> = ({ className }) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<RegisterPoliciesModel>()

  return (
    <div className={cnPoliciesStep(null, [className])}>
      <Tag className={cnPoliciesStep('title')}>
        {t('register-second-title')}
      </Tag>
      <div className={cnPoliciesStep('text')}>{t('register-first-text')}</div>
      <div className={cnPoliciesStep('checkboxes')}>
        <Controller
          name='conditions'
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <Checkbox
              id={name}
              name={name}
              checked={value}
              onChange={onChange}
              errors={errors.conditions?.message}
            >
              {t('accept-policies-label-1')}
              <NavLink to={'/terms-and-conditions'}>
                {t('accept-conditions')}
              </NavLink>
            </Checkbox>
          )}
        />

        <Controller
          name='concept'
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <Checkbox
              id={name}
              name={name}
              label={t('accept-policies-label-2')}
              checked={value}
              onChange={onChange}
              errors={errors.concept?.message}
            />
          )}
        />

        <Controller
          name='policy'
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <Checkbox
              id={name}
              name={name}
              checked={value}
              onChange={onChange}
              errors={errors.policy?.message}
            >
              {t('accept-policies-label-3')}
              <NavLink to={'/privacy-policy'}>
                {t('accept-privacy')}
              </NavLink>,{' '}
              <NavLink to={'/kyc-aml-policy'}>{t('accept-kyc-aml')}</NavLink>,{' '}
              <NavLink to={'/refund-policy'}>{t('accept-refund')}</NavLink>,{' '}
              {t('accept-policies-label-4')}
            </Checkbox>
          )}
        />
      </div>
    </div>
  )
}
